import { Link as RouterLink } from 'react-router-dom'
import {
  Box,
  Button,
  Flex,
  Heading,
  Text,
  useColorMode,
} from '@chakra-ui/react'

export function FinalCTA() {
  const { colorMode } = useColorMode()
  const isDark = colorMode === 'dark'

  return (
    <Box py={{ base: 20, md: 28 }} bg={isDark ? 'stone.900' : 'stone.50'}>
      <Flex direction="column" align="center" textAlign="center" px={6}>
        <Heading
          as="h2"
          fontFamily="heading"
          fontWeight={700}
          fontSize={{ base: '2rem', md: '2.5rem' }}
          letterSpacing="-0.025em"
          color={isDark ? 'stone.50' : 'stone.900'}
          mb={4}
        >
          Your AI writes Markdown.{' '}
          <Box as="br" display={{ base: 'none', md: 'block' }} />
          Give it somewhere to go.
        </Heading>
        <Text
          fontSize="1.125rem"
          color="stone.400"
          mb={10}
          maxW="460px"
        >
          Encrypted by default. Ready in seconds.
        </Text>
        <Button
          as={RouterLink}
          to="/editor"
          size="lg"
        >
          Start Sharing
        </Button>
      </Flex>
    </Box>
  )
}
